/* A constant variable that is storing the firebase configuration. */
const firebaseConfig = {
  apiKey: "AIzaSyADHGo_BrdrCZ1hjxej8JotxIemV48S1M8",
  authDomain: "stocky-g.firebaseapp.com",
  projectId: "stocky-g",
  storageBucket: "stocky-g.appspot.com",
  messagingSenderId: "259252357294",
  appId: "1:259252357294:web:0327d21ba33ae29ebcc53f",
};

export default firebaseConfig;
